<template>
    <DCard
        padding
        :title="`${__('settings.tenant_translations.key')} ${tenantTranslation.key}`"
    >
        <DRow>
            <DCol>
                <DForm @submit.prevent="submitForm">
                    <DFormRow
                        v-for="language in languages"
                        :key="language.key"
                        :label="language.label"
                        :hint="__('settings.tenant_translations.language_hint')"
                    >
                        <DInput
                            id="language.key"
                            v-model="form[language.key]"
                            add-input-classes="bg-light"
                            :is-valid="isFormFieldValid(language.key)"
                        />
                    </DFormRow>
                    <DFormControls
                        :cancel-route="cancel"
                        :dirty="form.isDirty"
                        @submit="submitForm"
                    />
                </DForm>
            </DCol>
        </DRow>
    </DCard>
</template>

<script setup>
import { route } from '~@/Composables/route'
import { useForm } from '@inertiajs/vue3'
import { computed } from 'vue'

const props = defineProps({
    tenantTranslation: {
        type: Object,
        default: () => {
            return {}
        }
    },
    languages: {
        type: Array,
        default: () => {
            return []
        }
    }
})

const form = useForm(props.tenantTranslation)
const submitForm = () => form.put(route('settings.tenant-translations.update', { tenant_translation: form }))
const cancel = computed(() => route('settings.tenant-translations.index'))
</script>

<style scoped lang="scss">

</style>
